import React, { useEffect, useState } from 'react';
import { Tabs } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import './ProgramSettings.css';
import {
	getAutomationSettings,
	selectAllAutomationSettings,
	selectAllCategories,
	createCategory,
	deleteCategory,
	createCategoryOption,
	deleteCategoryOption,
	updateCategory,
	updateCategoryOption,
	toggleCategoryEditor,
	updateAutomationSettings,
	getProgramCategories
} from '../programsSlice'
import { Tab } from 'react-bootstrap';
import { DebounceInput } from 'react-debounce-input';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link } from 'react-router-dom';
import { selectTrainerParam } from '../../users/usersSlice'


function ProgramSettings() {

  const dispatch = useDispatch()
	const show = useSelector(state=>state.programs.categoryEditor.show)
    
	//category state
	const [data, setData] = useState([]);
	const trainerParam = useSelector(selectTrainerParam)


	const [newCategory, setNewCategory] = useState(null)
	const [categoryNameUpdate, setCategoryNameUpdate] = useState(null)
	const categories = useSelector(selectAllCategories)
	const status = useSelector(state => state.programs.categoryEditor.status)
	const automationSettingsStatus = useSelector(state => state.programs.automationSettings.status)
	const automationSettings = useSelector(selectAllAutomationSettings)
	useEffect(() => {
		dispatch(getAutomationSettings())
		dispatch(getProgramCategories())
	}, []);

	//("automationSettings:-", automationSettings)
	const handleChangeAutomationSettings = (e) => {
		let enabled = '';
		if (e.target.checked) {
			enabled = 1
		} else {
			enabled = 0
		}
		dispatch(updateAutomationSettings({ enabled: enabled, automation_trigger_id: e.target.id, name: e.target.name }))
	}

	const [activeIndex, setActiveIndex] = useState("")
	const [tabs, setTabs] = useState("")




	return (
		<div className="ProgramSettings">
			<div>
				<Button
					variant='link'
					as={Link}
					to={`/programs?${trainerParam}`}
					style={{ paddingRight: '0px' }}
				> Programs</Button> / Program Settings

			</div>

			<div className="psHeader">
				<h2 className="mb-4 mt-2">Filter Category Editor</h2>
			</div>
			{
				categories.length < 5 ?
					<div>
						<div className="d-flex align-items-center justify-content-between">
							<span style={{ flex: '0 0 auto' }} className="mr-2">New category: </span>
							<Form.Control
								value={newCategory}
								onChange={e => {
									setNewCategory(e.target.value)
								}}
								placeholder="category name" />
							<Button
								onClick={() => {
									dispatch(createCategory(newCategory))
									setNewCategory('')
								}}
								className="ml-1"
								variant="outline-success">
								+
							</Button>
						</div>
						<div className="text-right text-primary">
							<small>{categories.length}/5 used</small>
						</div>
						<hr />
					</div> :
					<div className="text-right text-primary">
						<small className="mb-2">5/5 categories used</small>
					</div>
			}

			<DragDropContext onDragEnd={() => { }}>
				<div className="mb-2">
					<b> Current Categories</b>
				</div>
				<Tabs variant="pills" defaultActiveKey={(categories[0] || {}).id} id="uncontrolled-tab-example" >
					{categories.map((category, index) => (
						<Tab className="mt-2" eventKey={category.id} title={category.name}>
							<div className="d-flex align-items-center justify-content-between mb-2">
								<Form.Control
									placeholder={`update category name "${category.name}"`}
									onChange={e => {
										setCategoryNameUpdate(e.target.value)
									}} />
								<Button
									onClick={() => dispatch(updateCategory({
										name: categoryNameUpdate,
										category_id: category.id
									}))}
									style={{ flex: '0 0 auto' }}
									className="ml-1"
									variant="outline-success">
									Update Name
								</Button>
							</div>
							<div className="d-block mb-2 mt-3"><b> Sub Categories</b></div>
							<div className="d-flex flex-wrap">
								<Button
									onClick={() => dispatch(createCategoryOption(category.id))}
									variant="outline-dark"
									size="sm"
									style={{
										margin: '0 12px 12px 0'
									}}>
									<i className="fa fa-plus" />
								</Button>
								{
									category.options.length ?
										category.options.map(option => (
											<span style={{
												margin: '0 12px 12px 0',
												position: 'relative',
											}}>
												<DebounceInput
													minLength={0}
													debounceTimeout={300}
													value={option.name}
													className={["form-control", "form-control-sm"].join(' ')}
													placeholder="option name"
													onChange={e => dispatch(updateCategoryOption(
														{
															name: e.target.value,
															option_id: option.id,
															category_id: category.id
														}
													))} />
												<button
													onClick={() => {
														if (!window.confirm('Are you sure?')) return
														dispatch(deleteCategoryOption({
															category_id: category.id,
															option_id: option.id
														}))
													}
													}
													className="bg-danger text-white"
													style={{
														fontSize: '8px',
														position: 'absolute',
														width: '16px',
														height: '16px',
														border: 'none',
														borderRadius: '100%',
														top: '-8px',
														right: '-8px'
													}}>
													<i className="fa fa-times" />
												</button>
											</span>
										)) :
										<div>Add options to this category by clicking the "+" button</div>
								}
							</div>
							<hr />
							<div className="text-right mb-3">
								<Button
									className="ml-auto"
									onClick={() => {
										if (window.confirm('Are you sure?')) dispatch(deleteCategory(category.id))
									}}
									variant="outline-danger"
									size="sm">
									Delete {category.name} & All Options
								</Button>
							</div>
						</Tab>

					))}
				</Tabs>

			</DragDropContext>

			<div className="programSettings__automation">
				<div className="programSettings__heading">
					<h1>Automation Settings</h1>
					<p>Automatically prompt your clients if they have no future events (workouts/tasks/nutrition). They will be guided through the categories and will have programs automatically applied to their account. </p>
				</div>
				<div className="programSettings__checkbox">
					{
						automationSettings && automationSettings.map(data => (
							<FormControlLabel
								control={<Checkbox checked={data.enabled} onChange={handleChangeAutomationSettings} id={data.id} name={data.name} color="primary" />}
								label={data.name}
							/>
						))
					}
				</div>
			</div>
		</div>
	)
}

export default ProgramSettings
